import { render } from "./ViewAllUsers.vue?vue&type=template&id=1b78dcc8"
import script from "./ViewAllUsers.vue?vue&type=script&lang=js"
export * from "./ViewAllUsers.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__